/**
 * The header bell. VentaHub's three ticket notifications, said as a person
 * would: who did what, on which ticket; and the AI Analyst's two, about an
 * answer the reader asked to be told about.
 */
export const notifications = {
  title: 'Notifications',
  open: 'Notifications',
  openUnread_one: 'Notifications, {{count}} unread',
  openUnread_other: 'Notifications, {{count}} unread',
  unreadCount_one: '{{count}} unread',
  unreadCount_other: '{{count}} unread',
  markAllRead: 'Mark all as read',
  markRead: 'Mark as read',
  markUnread: 'Mark as unread',
  all: 'All',
  unread: 'Unread',
  filterLabel: 'Show',
  newer: 'New',
  earlier: 'Earlier',
  loading: 'Loading notifications…',
  failed: 'Could not load notifications.',
  retry: 'Try again',
  emptyTitle: "You're all caught up!",
  emptyBody: 'Assignments, comments and mentions on your tickets show up here.',
  emptyUnread: 'Nothing unread.',
  footnote: 'From the last 14 days',
  ticket: 'Ticket #{{number}}',
  someone: 'Someone',
  kind: {
    ticket_assigned: {
      title: 'Ticket assigned to you',
      body: '{{ticket}} · {{type}} is now yours to work.',
    },
    ticket_comment: {
      title: 'New comment',
      body: '{{actor}} commented on {{ticket}}',
    },
    ticket_mention: {
      title: 'You were mentioned',
      body: '{{actor}} mentioned you on {{ticket}}',
    },
    ai_analyst_ready: {
      title: 'Your AI Analyst answer is ready',
      body: 'Open the conversation to read it.',
    },
    ai_analyst_failed: {
      title: 'Your AI Analyst answer could not finish',
      body: 'Open the conversation to see what happened and try again.',
    },
    ai_analyst_alert: {
      title: 'AI Analyst alert',
      body: '{{title}}',
    },
  },
} as const
